import { render } from "./App.vue?vue&type=template&id=570f3f7a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=570f3f7a&lang=scss"

import exportComponent from "/Users/goyuntae/Desktop/bucket-list/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__